"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var utils_1 = require("./utils");
var Column = function (_a) {
    var column = _a.column, row = _a.row, children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column), className, column === 'name' && 'expand'), "data-key": "__".concat(column) },
        (0, utils_1.getColumnText)(column, row),
        children));
};
exports.default = Column;
